module.exports = __webpack_public_path__ + "static/media/sa.6f66c885.png";